import {
  AnalyticsEcommerceItem,
  AnalyticsEventName,
  AnalyticsEcommerceItemType,
  AnalyticsEvent,
} from './types';
import type { WorkspaceMaterial } from '../../types';
import type { ProductSearchMaterial } from '../../types';

export enum AddToCartMethod {
  SINGLE = 'Single',
  MULTI_SELECT = 'Multi-select',
}

export const getAnalyticsItemType = (
  item: any,
): AnalyticsEcommerceItemType | null => {
  if (!item) {
    return null;
  }

  const productFinishTypeValue =
    item.productFinishType ?? item.product_finish_type;
  if (productFinishTypeValue?.toLowerCase().includes('product')) {
    return AnalyticsEcommerceItemType.NON_SAMPLEABLE;
  } else if (productFinishTypeValue?.toLowerCase().includes('finish')) {
    return AnalyticsEcommerceItemType.FINISH;
  }

  return AnalyticsEcommerceItemType.SAMPLEABLE;
};

export const getAnalyticsItemCategoriesByTaxonomy = (
  taxonomy: string[] = [],
  keyPrefix: string | undefined = undefined,
) => {
  const itemCategory: string[] = [];
  const itemCategory2: string[] = [];
  const itemCategory3: string[] = [];

  taxonomy.forEach((value) => {
    const splittedTaxonomy = value.split('>') ?? [];

    if (splittedTaxonomy[0] && !itemCategory.includes(splittedTaxonomy[0])) {
      itemCategory.push(splittedTaxonomy[0]);
    }
    if (splittedTaxonomy[1] && !itemCategory2.includes(splittedTaxonomy[1])) {
      itemCategory2.push(splittedTaxonomy[1]);
    }
    if (splittedTaxonomy[2] && !itemCategory3.includes(splittedTaxonomy[2])) {
      itemCategory3.push(splittedTaxonomy[2]);
    }
  });

  const prefix = keyPrefix ? `${keyPrefix}_` : '';

  const obj: any = {};
  obj[`${prefix}item_category`] = itemCategory.join(', ');
  obj[`${prefix}item_category2`] = itemCategory2.join(', ');
  obj[`${prefix}item_category3`] = itemCategory3.join(', ');

  return obj;
};

export const getAnalyticsItemCategoriesByTaxonomyUs = (
  taxonomyUs: string = '',
) => {
  const itemCategory: string[] = [];
  const itemCategory2: string[] = [];
  const itemCategory3: string[] = [];
  const taxonomies = taxonomyUs.split('|');

  for (const taxonomy of taxonomies) {
    const dividedTaxonomy = taxonomy.split('.');

    if (dividedTaxonomy[0] && !itemCategory.includes(dividedTaxonomy[0])) {
      itemCategory.push(dividedTaxonomy[0]);
    }
    if (dividedTaxonomy[1] && !itemCategory2.includes(dividedTaxonomy[1])) {
      itemCategory2.push(dividedTaxonomy[1]);
    }
    if (dividedTaxonomy[2] && !itemCategory3.includes(dividedTaxonomy[2])) {
      itemCategory3.push(dividedTaxonomy[2]);
    }
  }

  return {
    item_category: itemCategory.join(', '),
    item_category2: itemCategory2.join(', '),
    item_category3: itemCategory3.join(', '),
  };
};

export const getBrandsPerBox = (
  ecommerceItems: AnalyticsEcommerceItem[],
): number => {
  const bpb = new Set();

  ecommerceItems.forEach((ecommerceItem) => {
    if (ecommerceItem.item_brand) {
      bpb.add(ecommerceItem.item_brand);
    }
  });

  return bpb.size;
};

export const getSearchItemVariant = (product: ProductSearchMaterial) => {
  const colorway = product.ssFacetColorFilter?.find(
    (color) => color.image_url === product.thumbnailImageUrl?.split('?')[0],
  );
  const itemColor = colorway ? colorway?.color_name : null;

  return itemColor ?? '';
};

export const getWorkspaceItemVariant = (product: WorkspaceMaterial) => {
  const colorway = product.ss_facet_color_filter?.find(
    (color) => color.image_url === product.thumbnailImageUrl?.split('?')[0],
  );
  const itemColor = colorway ? colorway?.color_name : null;
  const finishesColor = product.color || product.primary_color?.[0];

  return finishesColor ?? itemColor ?? '';
};

export const sendChangeViewAnalyticsEvent = (params: {
  eventLocation: string;
  type: 'Layout' | 'Sorting';
  action: string;
}) => {
  const { eventLocation, type, action } = params;
  mitGTM.sendEvent({
    event: AnalyticsEventName.CHANGE_VIEW,
    event_location: eventLocation,
    type,
    action,
  });
};

export const convertToDashCase = (inputString: string) => {
  // Convert the string to lowercase and replace spaces with hyphens to match the GA ids pattern
  const resultString = inputString.toLowerCase().replace(/ /g, '-');
  return resultString;
};

export const pushGtmDataLayer = (payload: AnalyticsEvent) => {
  try {
    mitGTM.sendEvent(payload);
  } catch (e) {
    console.log('pushGtmDataLayer error', e);
  }
};
